import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import * as Yup from 'yup';

import {
  AppForm,
  AppFormRadioField,
  AppFormSubmitButton,
} from '../../../../../../components/forms';
import Header2 from '../../../../../../components/headers/header2';
import {Column, Row} from '../../../../../../components/layout';
import {
  censorEmail,
  censorPhone,
  createGUID,
} from '../../../../../../util/utility';
import {strings} from '../../../../../../util/strings';
import * as fonts from '../../../../../../util/fonts';
import {get, post} from '../../../../../../api/api';
import {uriRequestActivationCode} from '../../../../../../api/endpoints';
import AppSpinner from './../../../../../../components/app-spinner/index';
import colors from '../../../../../../util/colors';
import {compose} from 'redux';
import {connect} from 'react-redux';

interface SelectContactProps {
  wizard: any;
  addToWizard(value: any): void;
  valid: boolean;
  setValid(value: any): void;
  labels: typeof strings.pt.register;
  globalStyles: any;
}

const validationSchema = Yup.object().shape({
  selectedContact: Yup.string().required(),
});

function SelectContact({
  wizard,
  addToWizard,
  valid,
  setValid,
  labels,
  globalStyles,
}: SelectContactProps) {
  const [contactType, setContactType] = useState('EMAIL');
  const [guid, setGuid] = useState(
    (wizard &&
      wizard.activateRegistration &&
      wizard.activateRegistration.guid) ||
      ''
  );
  const [loading, setLoading] = useState(false);

  const createContactOptions = () => {
    let options = [];

    if (wizard.dataValidation.currentUser?.email) {
      options.push({
        value: wizard.dataValidation.currentUser?.email,
        label: censorEmail(wizard.dataValidation.currentUser?.email),
      });
    }
    if (wizard.dataValidation.currentUser?.phone) {
      options.push({
        value: wizard.dataValidation.currentUser?.phone,
        label: censorPhone(wizard.dataValidation.currentUser?.phone),
      });
    }

    return options;
  };

  const handleWrongContacts = () => {
    addToWizard({
      dataValidation: {
        ...wizard.dataValidation,
        selectedContactType: 'EMAIL',
        currentUser: {
          contacts: {
            phone: '',
            email: '',
          },
        },
      },
    });
  };

  return (
    <Column className="add-contacts-container">
      <AppForm
        initialValues={{selectedContact: ''}}
        validationSchema={validationSchema}
        onValidation={(valid) => setValid(valid)}
        onSubmit={async (values) => {
          const guid = createGUID();

          try {
            setLoading(true);
            await post(
              uriRequestActivationCode(),
              JSON.stringify({
                senderType:
                  (values.selectedContact as string).indexOf('@') > -1
                    ? 'EMAIL'
                    : 'SMS',
                destination: values.selectedContact,
                sessionGuid: guid,
                name: wizard.insuranceValidation.name,
              })
            );
            setLoading(false);
            addToWizard({activateRegistration: {guid}});
            setGuid(guid);
          } catch (e: any) {
            setLoading(false);
          }

          addToWizard({
            dataValidation: {
              ...wizard.dataValidation,
              selectedContact: values.selectedContact,
              selectedContactType:
                (values.selectedContact as string).indexOf('@') > -1
                  ? 'EMAIL'
                  : 'SMS',
            },
          });
        }}>
        {!loading && (
          <>
            <Header2 className="activate-registration-header pt-2">
              {labels?.contactActivation_subTitle}
            </Header2>
            <AppFormRadioField
              className="activate-registration-radio-select activate-registration-row"
              name="selectedContact"
              options={createContactOptions()}
            />
            <Row className="activate-registration-row">
              <div style={{...fonts.M, fontWeight: 'normal'}}>
                {`${labels?.contactActivation_underText}`}
                <a
                  style={{color: globalStyles?.primaryColor}}
                  href=""
                  onClick={handleWrongContacts}>
                  {' '}
                  {labels?.contactActivation_linkText}
                </a>
              </div>
            </Row>
            <Row className="insurance-validation-continue-button-row">
              <AppFormSubmitButton
                title={labels?.insuranceAndPhone_confirmButtonText}
                disabled={!valid}
                className="stepper-continue-button"
              />
            </Row>
          </>
        )}
        {loading && <AppSpinner type="grey"></AppSpinner>}
      </AppForm>
    </Column>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(SelectContact));
